/**
 * @file Export MultiSelectSearchInput molecule.
 */

export { default } from "./MultiSelectSearchInputContainer";
